export enum DataSource {
  PublishedGartnerResearch = 15495
}
